<template>
  <NavBar data-test-id="shift-navbar">
    <template #left>
      <div role="button" tabindex="0" @click="back" @keydown.enter="back">
        <back-arrow></back-arrow>
      </div>
    </template>
    <template #center>
      <div class="auto-logout-navbar-header">Auto Logout</div>
    </template>
    <template #right>
      <div class="auto-logout-navbar-done" role="button" tabindex="0" @click="done" @keydown.enter="done">Done</div>
    </template>
  </NavBar>
</template>

<script>
import NavBar from "@/App/components/NavBar";
import BackArrow from "@/Shift/components/back-arrow.vue";

export default {
  name: "Navbar",

  components: {
    BackArrow,
    NavBar,
  },

  props: {
    done: {
      required: true,
      type: Function,
    },
    back: {
      required: true,
      type: Function,
    },
  },
};
</script>

<style scoped>
.auto-logout-navbar-header {
  color: #bf1311;
  font-size: 1.2rem;
  font-weight: bold;
}

.auto-logout-navbar-done {
  color: #bf1311;
  font-size: 0.85rem;
  text-transform: uppercase;
}
</style>
